<div class="work-income">
  @for (subfield of field.fieldGroup; track subfield; let i = $index) {
    <div class="">
      <div class="d-flex col-md-9">
        @if (props.text && subfield.index === 0) {
          <label [attr.for]="id" class="form-label align-items-center {{ labelIndentCssClass }}"
            [attr.role]="props.group ? 'presentation' : null">
            <span class="question-label-text font-weight-bold" [id]="id + key?.toString()">{{ props.text }}</span>
            @if (props.tooltip) {
              <span class="help-tooltip-icon ms-2" [ngbTooltip]="tooltipContent"
              tooltipClass="help-tooltip" triggers="click" role="tooltip"></span>
            }
            <ng-template #tooltipContent>
              <div [innerHtml]="props.tooltip"></div>
            </ng-template>
          </label>
        }
      </div>
      <div class="d-flex">
        <div class="col-md-9">
          @if (i > 0) {
            <hr class="mob-separator">
          }
          <div class="d-flex mb-3 work-income-group">
            <formly-field class="col px-0 work-income-amount" [field]="subfield.fieldGroup[0]"></formly-field>
            <formly-field class="col px-0 ms-4 work-income-percent" [field]="subfield.fieldGroup[1]"></formly-field>
          </div>
        </div>
        @if (subfield.index !== confirmView) {
          <div class="col-1 mt-auto action-btns">
            @if (canDeleteField(subfield)) {
              <div role="button" class="btn btn-grey icon-trash ms-3"
                (click)="toggleConfirmView(subfield.index)">
              </div>
            }
          </div>
        }
        @if (subfield.index === confirmView) {
          <div class="col-2 mt-auto action-btns d-flex">
            <div role="button" class="btn btn-success icon-checkmark ms-3 me-1" (click)="deleteField(subfield)">
            </div>
            <div role="button" class="btn btn-danger icon-close ms-1" (click)="toggleConfirmView(null)">
            </div>
          </div>
        }
      </div>
    </div>
  }
  <div class="d-flex col mb-4 d-print-none">
    <div role="button" class="btn btn-primary icon-add" (click)="addNewField()"></div>
  </div>